import * as React from "react";
import * as ReactDOM from "react-dom";
import * as utils from "../../utils/utils";

export interface IDropDownProperties
{
    /**
     * Wenn angegeben, kann hiermit das DOM-Element dieser Komponente ermittelt werden.
     */
    dropDownRef?: (elem: HTMLElement) => void,

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Enthält alle Child-Elemente.
     */
    children?: any,

    /**
     * Wird benötigt um das Menü an die ComboBox auszurichten.
     */
    comboboxContainerRef: HTMLElement,

    ///**
    // * Wird benötigt um das Menü an die ComboBox auszurichten.
    // */
    //comboboxRef: HTMLElement,

    /**
     * Ein Wert der angibt, ob das DropDown offen ist.
     */
    show: boolean,

    /**
     * Enthält die maximale Höhe des DropDowns.
     */
    maxHeight?: number
}

export class DropDown extends React.Component<IDropDownProperties>
{
    /**
     * Initialisiert die Komponente @see DropDown.
     * @param props Die Eigenschaften dieser Komponente.
     */
    constructor(props: IDropDownProperties)
    {
        super(props);
    }

    /**
     * Ermittelt die Position für das DropDown Menü.
     */
    private getMenuPosition()
    {
        const browserSize = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        //const refInfo = {
        //    width: this.props.comboboxRef.offsetWidth,
        //    height: this.props.comboboxRef.offsetHeight,
        //    top: this.props.comboboxRef.getBoundingClientRect().top,
        //    left: this.props.comboboxRef.getBoundingClientRect().left
        //};

        //var top = refInfo.top + refInfo.height + 1;
        //var left = refInfo.left;
        //var width = refInfo.width;
        //var maxHeight = this.props.maxHeight;

        const refInfo = {
            width: this.props.comboboxContainerRef.offsetWidth,
            height: this.props.comboboxContainerRef.offsetHeight,
            top: this.props.comboboxContainerRef.offsetTop,
            left: this.props.comboboxContainerRef.offsetLeft
        };

        var top = refInfo.top + refInfo.height + 1;
        var left = refInfo.left;
        var width = refInfo.width;
        var maxHeight = this.props.maxHeight;

        return {
            top: top,
            left: left,
            width: width,
            maxHeight: maxHeight
        };
    }

    /**
     * Rendert die Komponente.
     */
    render()
    {
        if (!this.props.show)
            return null;

        const position = this.getMenuPosition();

        return (
            <div
                ref={this.props.dropDownRef}
                className="combobox-dropdown"
                style={{
                    top: position.top,
                    left: position.left,
                    width: position.width,
                    ...this.props.style
                }}>
                {this.props.children}
            </div>
        );
    }
}